import ObjectToQueryString from "utils/ObjectToQueryString";
import * as actions from "./actionTypes";
import * as config from "config";

/*
export function searchCompanyInfo(search) {
    return {
        type: config.apiRequestStart,
        payload: {
            
            baseUrl: "",
            url: config.apiRcSearchCompanies,

            // baseUrl: "",
            // url: "https://cors-anywhere.herokuapp.com/" + config.apiRcSearchCompanies,

            // baseUrl: "https://postapp.cac.gov.ng/postapp/api",
            // url: "/front-office/search/company-business-name-it",

            method: "post",
            data: {
                "classification": {
                    "id": 0
                },
                "searchTerm": search,
                "selectedCompanyId": null,
                "isViewFee": false
            },
            onStart: actions.SEARCH_COMPANIES_START,
            onSuccess: actions.SEARCH_COMPANIES,
            onError: actions.SEARCH_COMPANIES_FAILED,
            useLoginJwt: false,
        },
    }
}
*/

export function searchCompanyInfo(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiRcSearchCompaniesBackend + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.SEARCH_COMPANIES_START,
            onSuccess: actions.SEARCH_COMPANIES,
            onError: actions.SEARCH_COMPANIES_FAILED,
        },
    }
}

export function resetSearchCompanyInfo() {
    return {
        type: actions.SEARCH_COMPANIES_RESET,
        payload: {},
    }
}